import React, { useContext, Fragment, useEffect, useState } from "react";
import { AppContext, GameBoardContext } from "../context/createContext";
import { isMobile, isTablet } from "react-device-detect";
import useGameBoardContextUpdate from "../helpers/useGameBoardContextUpdate";
import Settings from "../pages/settings/Settings";
import LiveScores from "./footer/elements/liveScores/LiveScores";
import Footer from "./footer/Footer";
import GameBoard from "./gameBoard/GameBoard";
import { GameBoardWrapper, GlobalStyles } from "./GameStyles";
import Header from "./header/Header";
import {
  StarBackground,
  initializeGraphics,
  getResourses,
} from "./pixiBoard/PixiBoard";
import Notification from "./notification/Notification";
import useStellarLoader from "../pages/loader/useStellarLoader";
import useMusic from "../hooks/useMusic";
import { loaderConfig } from "./pixiBoard/flow/planetsArray"
import useSoundSwitcher from "../hooks/useSoundSwitcher";
import Jackpot from "../modals/jackpot/Jackpot";
import useJackpotStates from "../helpers/useJackpotStates";
import useJackpotSounds from "../hooks/useJackpotSounds";
// import FPSLogger from "./fpslogger";
import { getGPUTier } from 'detect-gpu';

export default function Game() {
  let allResourses: any = [];

  if (isMobile || isTablet) {
    allResourses = loaderConfig.mobile
    //const gpuTier = await getGPUTier();
  } else {
    allResourses = loaderConfig.desktop
  }

  allResourses = allResourses.concat(getResourses());

  const { Loading, isLoading, progress, loaderIsFinished } = useStellarLoader(
    getResourses(),
    function () {
      initializeGraphics();
    }
  );
  const { ctx } = useGameBoardContextUpdate();
  const {
    funcs,
    settings: { showSettings, settingsSubpage },
    jackpotPopup,
    stakes,
  } = ctx;
  const { handleStake, handleJackpotPopup } = funcs;
  const {
    handleNotification,
    notification,
    notificationfadeOut,
    isError,
    errorText,
    // str,
    appFuncs,
    jackpotState,
    history,
    settings,
    config,
  } = useContext(AppContext);
  const { setAudio } = appFuncs;

  const [isJackpot, setIsJackpot] = useState(false);
  useMusic(isLoading, isError, errorText, isJackpot);
  useJackpotSounds(isLoading, isError, errorText);
  useSoundSwitcher();

  useEffect(() => {
    const prec = config.prec;
    const minbet = config.minbet;
    if (settings.stakes) {
      handleStake(settings.stakes.firstStake, settings.stakes.secondStake);
    } else if (minbet !== 0) {
      if (
        (stakes.firstStake === "" || Number(stakes.firstStake) <= 0) &&
        (stakes.secondStake === "" || Number(stakes.secondStake) <= 0)
      ) {
        handleStake(minbet.toFixed(prec), minbet.toFixed(prec));
      } else {
        if (stakes.firstStake === "" || Number(stakes.firstStake) <= 0) {
          handleStake(minbet.toFixed(prec), stakes.secondStake);
        }
        if (stakes.secondStake === "" || Number(stakes.secondStake) <= 0) {
          handleStake(stakes.firstStake, minbet.toFixed(prec));
        }
      }
    }
    settings.audio && setAudio(settings.audio);
  }, [settings, config]);

  const errorClickHandler = () =>
    isError || (notification && handleNotification(false));

  const { tempRemoveComponents, removeComponents } = useJackpotStates(
    jackpotState.state,
    jackpotPopup,
    handleJackpotPopup
  );

  // const { fps } = FPSLogger();

  return (
    <GameBoardContext.Provider value={ctx}>
      {isLoading && !errorText && (
        <Loading progress={progress} loaderIsFinished={loaderIsFinished} />
      )}
      <StarBackground
        isLoading={isLoading}
        setIsJackpot={setIsJackpot}
        isJackpot={isJackpot}
        jackpotPopup={jackpotPopup}
      />
      {!errorText && (
        <Fragment>
          <GlobalStyles
            mobile={isMobile}
            settings={showSettings}
            subPage={settingsSubpage}
          />
          <Header
            isLoading={isLoading}
            tempRemoveComponents={tempRemoveComponents}
          />
          {jackpotPopup && !isLoading && (
            <Jackpot
              handleJackpotPopup={handleJackpotPopup}
              setIsJackpot={setIsJackpot}
            />
          )}
          <GameBoardWrapper isLoading={isLoading} popup={jackpotPopup}>
            <div className="box" onClick={() => errorClickHandler()}>
              <GameBoard
                removeComponents={removeComponents}
                tempRemoveComponents={tempRemoveComponents}
                jackpotPopup={jackpotPopup}
                isJackpot={isJackpot}
              />
              <Footer
                removeComponents={removeComponents}
                popup={jackpotPopup}
                isJackpot={isJackpot}
                isLoading={isLoading}
              />
              <Settings history={history} />
            </div>
            <LiveScores
              removeComponents={removeComponents}
              popup={jackpotPopup}
            />
          </GameBoardWrapper>
        </Fragment>
      )}
      {errorText && (
        <Notification
          text={errorText}
          fadeOut={notificationfadeOut}
          isError={true}
        />
      )}
    </GameBoardContext.Provider>
  );
}
